module.exports = __webpack_public_path__ + "static/media/2fa-sms.aac4f212.svg";